"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAdLog = exports.logShareEventAnon = exports.logActionEvent = void 0;
const constants_1 = require("../../constants/constants");
const storageUtils_1 = require("../utils/storageUtils");
const axiosConfig_1 = require("../axios/axiosConfig");
const logActionEvent = (cred_no, action, organization_id, recipient_group_id) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let userId = (0, storageUtils_1.getItem)(constants_1.StorageKeys.user_id) || 0;
        yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EventRoutes.logActionEvent(), {
            user_id: userId,
            platform: 1,
            value: cred_no,
            string_value: null,
            type: action,
            organization_id,
            recipient_group_id,
        });
    }
    catch (err) {
        console.log(err);
    }
});
exports.logActionEvent = logActionEvent;
const logShareEventAnon = (credNo, sharingFor, organization_id, linkedinShareData) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let userId = (0, storageUtils_1.getItem)(constants_1.StorageKeys.user_id) || 0;
        yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EventRoutes.handleShareAnon(), {
            credential_no: credNo,
            sharingFor: sharingFor,
            organization_id,
            user_id: userId,
            linkedinShareData: linkedinShareData,
        });
    }
    catch (_a) {
        console.log("err on logShareEvent activity.");
    }
});
exports.logShareEventAnon = logShareEventAnon;
const generateAdLog = (viewerId, eventType, referrerUrl, deliveryId, credNo, adLinkId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let res = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EventRoutes.createAdLog(), {
            user_id: viewerId,
            type: eventType,
            referrer_url: referrerUrl,
            delivery_id: deliveryId,
            certificate_no: credNo,
            ad_link_id: adLinkId,
        });
        if (res.data.success) {
            console.log("log created successfully");
        }
    }
    catch (err) {
        console.log(err);
    }
});
exports.generateAdLog = generateAdLog;
